import { transformToManagerPipelineStages } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/transformers/manager-pipeline-summary-transformers';
import { useGeneratedSalesPortalManagerPipelineSummaryQuery } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/documents/sales-portal-manager-pipeline-summary.generated';
import { useMemo } from 'react';
import type { ApolloError } from '@apollo/client';
import type { ManagerPipelineStageData } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

interface UseManagerPipelineSummaryLoaderParams {
  businessOrganizationUUID: string;
  employeeUUIDs: string[];
}

interface UseManagerPipelineSummaryLoaderResult {
  pipelineError?: ApolloError;
  pipelineLoading: boolean;
  pipelineStages: ManagerPipelineStageData[];
  refetchPipeline: () => void;
}

export function useManagerPipelineSummaryLoader({
  businessOrganizationUUID,
  employeeUUIDs,
}: UseManagerPipelineSummaryLoaderParams): UseManagerPipelineSummaryLoaderResult {
  const {
    data: pipelineData,
    error: pipelineError,
    loading: pipelineLoading,
    refetch,
  } = useGeneratedSalesPortalManagerPipelineSummaryQuery({
    notifyOnNetworkStatusChange: true,
    variables: { businessOrganizationUUID, employeeIds: employeeUUIDs },
  });

  const pipelineStages = useMemo(
    () =>
      transformToManagerPipelineStages(
        pipelineData?.getSalesPortalManagerPipelineSummary ?? [],
      ),
    [pipelineData],
  );

  return {
    pipelineError,
    pipelineLoading,
    pipelineStages,
    refetchPipeline: () => {
      refetch().catch(() => {});
    },
  };
}
